export default __webpack_public_path__ + "static/media/sidebar-right.93675594.svg";